import jwtDecode from "jwt-decode";
import axios from "axios";
import config from "../../config";

// Configuración predeterminada de axios
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.baseURL = config.API_URL;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message;
    if (error && error.response && error.response.status === 404) {
     
    } else if (error && error.response && error.response.status === 403) {
      window.location.href = "/access-denied";
    } else {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 403:
          message = "Access Forbidden";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default: {
          message =
            error.response && error.response.data
              ? error.response.data["message"]
              : error.message || error;
        }
      }
      return Promise.reject(message);
    }
  }
);

const AUTH_SESSION_KEY = "ubold_user";

/**
 * Establecer la autorización en los headers
 */
const setAuthorization = (token: string | null) => {
  if (token) axios.defaults.headers.common["Authorization"] = "JWT " + token;
  else delete axios.defaults.headers.common["Authorization"];
};

/**
 * Obtener el usuario desde sessionStorage
 */
const getUserFromCookie = () => {
  const user = localStorage.getItem("user"); // o la clave que uses
  return user ? JSON.parse(user) : null;
};

class APICore {
  /**
   * Realizar una petición GET
   */
  get = (url: string, params: any) => {
    let response;
    if (params) {
      const queryString = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }
    return response;
  };

  /**
   * Realizar una petición POST
   */
  create = (url: string, data: any) => {
    return axios.post(url, data);
  };

  /**
   * Verificar si el usuario está autenticado
   */
  isUserAuthenticated = () => {
    const user = this.getLoggedInUser();
    if (!user) {
      return false;
    }

    const decoded: any = jwtDecode(user.token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * Guardar el usuario autenticado en sessionStorage
   */
  setLoggedInUser = (session: any) => {
    if (session)
      sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
    else sessionStorage.removeItem(AUTH_SESSION_KEY);
  };

  /**
   * Obtener el usuario autenticado desde sessionStorage
   */
  getLoggedInUser = () => {
    return getUserFromCookie();
  };
  
  /**
   * Actualizar los datos del usuario en sessionStorage
   */
  setUserInSession = (modifiedUser: any) => {
    let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
    if (userInfo) {
      const { token, user } = JSON.parse(userInfo);
      this.setLoggedInUser({ token, ...user, ...modifiedUser });
    }
  };
}

/*
Verificar si el token está disponible en sessionStorage al iniciar
*/
let user = localStorage.getItem("user");
if (user) {
  const userObj = JSON.parse(user);
  const { token } = userObj;
  if (token) {
    setAuthorization(token);
  }
}

export { APICore, setAuthorization };
